import React, { FC } from 'react';
import { Loader } from 'react-bulma-components';
import * as styles from './BigLoader.module.scss';

const BigLoader: FC = () => {
  return <Loader className={styles.loader} />;
};

export default BigLoader;
